import React, { useEffect } from 'react';

const REDIRECT_PATH = 'https://danubehome.com/';

const Reschedule = () => {
  useEffect(() => {
    console.log('Component mounted. Attempting redirect to:', REDIRECT_PATH);
    const queryParams = new URLSearchParams(window.location.search);
    const orderId = queryParams.get('order_id');
    const status = queryParams.get('status');
    
    if (orderId && status) {
    const rescheduleData = {
        orderId,
        status,
    };
    fetch(`${process.env.SELLER_HUB_SELLER_GRAPHQL_API}/api/v1/update-reschedule-status`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer VEZNIFNUQVRVUyBVUERBVEUgQ0FMTA==`,
      },
      body: JSON.stringify(rescheduleData),
    })
      .then((response) => response.json())
      .catch((error) => console.error('Error calling reschedule API:', error));
      
    }
    // window.location.href = REDIRECT_PATH;

  }, []);
  return <>This is reschedule redirect page.</>;
};

export default Reschedule;
